import { createLogger } from '@genesislcap/foundation-logger';
import { showBanner } from './banner';
import { showDialog } from './dialog';
import { getErrorDetails, getLoglevel } from './error-util';
import { showNotification } from './notification';
import { showSnackbar } from './snackbar';
const logger = createLogger('foundation-error');
const errorTypeToComponentMap = {
    alert: (error) => {
        alert(getErrorDetails(error));
    },
    notification: showNotification,
    dialog: showDialog,
    snackbar: showSnackbar,
    banner: showBanner,
};
/**
 * Shows the error in the appropriate component
 * @public
 * @param error - The ErrorStructure object
 * @param tagName - The tag name to create prefix for the design system provider *
 * @param errorBoundary - The error boundary element
 * @returns
 * */
export const showError = (error, tagName, errorBoundary) => {
    logger.log({
        message: getErrorDetails(error),
        level: getLoglevel(error),
    });
    const keys = Object.keys((error === null || error === void 0 ? void 0 : error.config) || {});
    keys.forEach((key) => {
        if (errorTypeToComponentMap[key]) {
            errorTypeToComponentMap[key](error, tagName, errorBoundary);
        }
    });
};
